import { StatisticsApi } from "../../../api/statistics/StatisticsApi";
import * as React from "react";

const StatisticsContext = React.createContext<StatisticsApi | null>(null);
export default StatisticsContext;
